import SceneController from 'controllers/sceneController';

export default class AdminSceneController extends SceneController {
    show() {
    }
}
